<template>
  <div class="input-container">
    <div v-if="isGiftEdition" class="total-value">Valor total:</div>
    <div class="input-row">
      <button
        v-if="isGiftEdition"
        class="button-action decrease-value"
        type="button"
        @click="updatePrice(false)"
        :disabled="disabledDecrease"
      >
        -20%
      </button>
      <b-field
        ref="field"
        :type="{
          'is-danger': hasError,
        }"
        :message="hasError ? message : ''"
        class="c-base-buefy-input-price"
        :label="!isGiftEdition ? 'Valor total:' : ''"
      >
        <b-input type="tel" v-money="money" v-model.lazy="price" />
      </b-field>
      <button
        v-if="isGiftEdition"
        class="button-action increase-value"
        type="button"
        @click="updatePrice(true)"
      >
        +20%
      </button>
    </div>
  </div>
</template>

<script>
import { VMoney } from 'v-money'
import currency from 'currency.js'

export default {
  props: {
    initialPrice: {
      type: Number,
    },
    isGiftEdition: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      price: 0,
      disabledDecrease: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      onFocus: '',
      isTouched: '',
    }
  },

  watch: {
    // Watch and emit event when price changed with of value
    price(payload) {
      const value = this.stringToNumber(payload)
      const currency = this.numberToString(payload)
      this.$emit('price', {
        currency: currency,
        value,
      })
      if (!this.isTouched && value != 0) this.isTouched = true
    },
  },

  mounted() {
    if (this.initialPrice)
      this.$refs.field.$el.getElementsByTagName('input')[0].value =
        this.numberToString(this.initialPrice)
  },

  methods: {
    updatePrice(increase) {
      const totalValue = this.stringToNumber(this.price)
      const percentage = totalValue * 0.2
      let increaseValue = this.numberToString(totalValue + percentage)
      let decreaseValue = this.numberToString(totalValue - percentage)
      this.disabledDecrease = false

      if (increase) {
        this.price = increaseValue
        this.$refs.field.$el.getElementsByTagName('input')[0].value =
          increaseValue
      } else {
        if (this.stringToNumber(decreaseValue) >= 1) {
          this.price = decreaseValue
          this.$refs.field.$el.getElementsByTagName('input')[0].value =
            decreaseValue
        } else {
          this.disabledDecrease = true
        }
      }
    },
    stringToNumber(value) {
      return currency(value, {
        separator: '.',
        decimal: ',',
      }).value
    },

    numberToString(value) {
      return currency(value, {
        separator: '.',
        decimal: ',',
      }).format()
    },
  },

  directives: { money: VMoney },
}
</script>

<style lang="scss">
.input-container {
  .total-value {
    color: $neutral;
    font-weight: 700;
    margin-bottom: 8px;
  }
  .input-row {
    display: flex;
  }
  .c-base-buefy-input-price {
    flex: 1;
  }
  .button-action {
    width: 63px;
    height: 48px;
    padding: 8px;
    border-radius: 8px;
    font-family: 'Lato', sans-serif;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    &:disabled {
      cursor: not-allowed;
    }
    &.decrease-value {
      margin: 0 8px 0 0;
      border: 1px solid #d9e2eb;
      background: #f2f7fc;
      color: $neutral;
      &:active,
      &:disabled {
        border: 1px solid #d9e2eb;
        background: #d9e2eb;
      }
    }
    &.increase-value {
      margin: 0 0 0 8px;
      border: 1px solid #3dafb0;
      background: rgba(176, 228, 230, 0.2);
      color: $support;
      &:active {
        border: 1px solid #3dafb0;
        background: rgba(176, 228, 230, 0.7);
      }
    }
  }
}
.c-base-buefy-input-price {
  .label {
    color: $neutral;
    margin-bottom: 8px;
  }
  .control {
    height: 100%;
    padding: 0;
    border: 0;
    box-shadow: none;

    .input {
      width: 100%;
      height: 48px;
      color: $neutral;
      padding-left: 12px;
      border: 1px solid $neutrallight;

      &.is-danger {
        border-color: $error;
      }
    }

    &.has-icons-right {
      .icon {
        height: 48px;
      }
    }
  }

  .help.is-danger {
    color: $error;
  }
}
</style>
